import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetGroupDetailById(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/getGroupDetailById`,
    params,
  });
}
